import React, { useEffect, useMemo, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Await, defer, useLoaderData } from 'react-router-dom';
import { addGroup, getGroups } from '../../Api Methods/Api';
import GroupsGrid from './GroupsGrid';
import Button1 from '../../components/UI/Button/Button1';
import Modal from '../../components/Modal/Modal';
import InputForm from '../../components/forms/InputFormCreateGroup';
import DataManager from '../../hooks/DataManager';
import Stats2 from '../../components/UI/Stats/Stats2';
import DeviceLoadingGrid from '../../components/GridList/DeviceLoadingGrid';
import classes from './GroupsGrid.module.css'
import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import { serviceActions } from '../../store/service-Slice';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Lottie from 'lottie-react';


const Groups = () => {
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);
  const [title, setTitle] = useState("Create group");

  const cachedGroups = useSelector(state => state.service.GroupsTableData);
  const [groups, setGroups]  = useState(cachedGroups);
  const [modalComponent, setModalComponent] = useState();
  const [name, setName] = useState('')
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [update, setUpdate] = useState(0);
  const [isCreateGroupVisible, setIsCreateGroupVisible] = useState(false)
  const [successVisible, setSuccessVisible] = useState(false)

  const [isLoading, setIsLoadng] = useState(() => {
    return !cachedGroups || cachedGroups.length === 0;
  });    
  const [isLoadingStats, setIsLoadingStats] = useState(true)

  const dataManager = new DataManager();

  const apiData = {
    token,
    client
  }

  useEffect(() => {
    console.log(selectedGroup)
  }, [selectedGroup])

  useEffect(() => {
  }, [name])

  const dispatch = useDispatch();

  const HandleGetGroups = async () => {
    const data = await getGroups(apiData, dispatch)
    const sortedData = data.sort((a, b) => a.name.localeCompare(b.name))
    setGroups(sortedData)
    dispatch(serviceActions.setGroupsTableData(sortedData));

    setIsLoadng(false)
    setIsLoadingStats(false)
    localStorage.setItem('groups', JSON.stringify(data));
  }

  useEffect(() => {
    HandleGetGroups()
  }, [update])

  const ModalDialog = useRef();

  // const handleCreateGroups = () => {
  //   setModalComponent(
  //     <div>
  //     <br/>
  //         <InputForm label={"Enter name of group"} setName={setName}></InputForm>
       
  //       <div>

  //       <Dropdown
  //           value={selectedGroup}
  //           className="w-full md:w-14rem"
  //           style={{ width: '300px' }}  
  //           onChange={(e) => setSelectedGroup(e.value)}
  //           options={groups}
  //           optionLabel="name"
  //           placeholder="Choose group"
  //           filter                 
  //           filterPlaceholder="Search groups..."
  //       />

  //         {/*<Dropdown label={"Please select the parent group below"} dropDownOptions={groupNames} setSelectedGroup={setSelectedGroup} />*/}
  //       </div>
  //       <br></br>
  //       <Button1 onClick={createGroup}>Create</Button1>
  //     </div>
  //   )  
  //   HandleShowModal();
  // }

  const showError = () => {
    setModalComponent(
      <div>
        <div>
          <h3>Error</h3>
        </div>
        <br></br>
        <div>
         <p>Error creating group, please try again later.</p>
        </div>
        <br></br>
        <Button1 onClick={HandleCloseModal}>Close</Button1>
      </div>
    )  
    HandleShowModal();
  }

  const createGroup = async () => {
    const _groupName = dataManager.getItem('groupName');

    const body = {
      groupName: _groupName.trim(), 
      parentID: selectedGroup.id
    }

    if (_groupName !== '' && selectedGroup !== ''){
      const response = await addGroup(apiData, body, dispatch)
      if (response.success){
        HandleGetGroups();
        HandleCloseModal();
        setSuccessVisible(true)
        setIsCreateGroupVisible(false)
        //refresh
      } else {
        showError();
        //error
      }
    } else {
      //invalid form
    }
  }

  const HandleShowModal = () => {
    ModalDialog.current.open();
  };

  const HandleCloseModal = () => {
    ModalDialog.current.close();
    setTitle("Create group")
  };

  return ( 
    <>
      <Modal ref={ModalDialog} title={"Create group"} modalName={""} HandleShowModal={HandleShowModal}>
          {modalComponent}
      </Modal>


      <Dialog
          header="Create group"
          visible={isCreateGroupVisible}
          style={{ width: "40vw" }}
          onHide={() => setIsCreateGroupVisible(false)}
          >
          <div>
          {/* Choose group */}
          <InputForm label={"Enter name of group"} setName={setName}></InputForm>

          <p>Choose the parent group from the dropdown below</p>
              <Dropdown 
              value={selectedGroup} 
              onChange={(e) => setSelectedGroup(e.value)} 
              options={groups} 
              optionLabel="name"
              showClear
              filter
              placeholder="Select a group" 
              className="w-full md:w-14rem" />

          </div>

          <br></br>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button label="Next" severity="success" disabled={!selectedGroup} onClick={createGroup} />
          </div>
        </Dialog>

        <Dialog
            header="Success"
            visible={successVisible}
            style={{ width: "40vw" }}
            onHide={() => setSuccessVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff"}}>Group created successfully!.</h3>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />

                <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setSuccessVisible(false)}/>
            </div>
        </Dialog>

      <Await resolve={groups}>
        {(loadedTotalGroups) => 
          <div style={{ display: "flex", width: "100%" }}>
            {groups && <Stats2 title={"Total groups"} value={loadedTotalGroups.length}  isLoadingStats={isLoading} isStatic={true} />}
          </div>
        }
      </Await>
              

      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "30px", marginTop:"15px"}}>
          <Button1 style={{height: "50px", width: "160px", "font-size": "16px"}} onClick={() => setIsCreateGroupVisible(true)}>Create new group</Button1>
        </div>

        {groups ? (
          <GroupsGrid GroupsList={groups} setUpdate={setUpdate} update={update}></GroupsGrid>
        ) : (
          <div style={{ display: "flex", width: "100%" }}>
          <DeviceLoadingGrid
            CardCount={20}
          />
        </div>
        )}
      </div>
    </>
  );
}

export default Groups

export async function loader() {
  const token = localStorage.getItem('token');
  const client = localStorage.getItem('client');

  const apiData = {
    token,
    client
  }

  return defer({
    groups: getGroups(apiData)
  })
}